import { render, staticRenderFns } from "./ImageItem5Template.vue?vue&type=template&id=f1d49e52"
import script from "./ImageItem5Template.vue?vue&type=script&lang=js"
export * from "./ImageItem5Template.vue?vue&type=script&lang=js"
import style0 from "./ImageItem5Template.vue?vue&type=style&index=0&id=f1d49e52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports